import React from "react";
import { Link } from "react-router-dom";
import SEOHead from "./SEOHead";
import { doctorProfileSchema } from "../data/seoSchemas";
import "./DoctorProfile.css";

const DoctorProfile = () => {
  return (
    <div className="doctor-profile">
      <SEOHead
        title="About Dr. Sunil Apsingi | MS Ortho PGI Chandigarh | Senior Joint Surgeon"
        description="Learn more about Dr. Sunil Apsingi, MS Ortho (PGI Chandigarh), Senior Consultant in Arthroscopy & Robotic Joint Replacement with 23+ years of surgical experience at Medicover Hospitals, Hyderabad."
        canonicalPath="/profile"
        schemaJson={doctorProfileSchema}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Doctor Profile", path: "/profile" },
        ]}
      />
      {/* Hero Header Section */}
      <div className="hero-section">
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <span className="section-header-pill mb-2">
            <i className="fa-solid fa-user-doctor me-1"></i> Senior Consultant Profile
          </span>
          <h1>Dr. Sunil Apsingi</h1>
          <p className="qualification">MS Orthopedics (PGI, Chandigarh)</p>
          <p className="role">Chief Arthroscopy & Joint Replacement Surgeon</p>
        </div>
      </div>

      <div className="container content-wrapper">
        <div className="row g-4">
          {/* Main Profile Card (Floating) */}
          <div className="col-12">
            <div className="card profile-card main-info">
              <div className="card-body p-0">
                <div className="row g-0 align-items-center">
                  <div className="col-md-4 col-lg-3 text-center p-4">
                    <img
                      alt="Dr. Sunil Apsingi"
                      className="profile-image"
                      src="/images/2022-05-13.png"
                    />
                  </div>
                  <div className="col-md-8 col-lg-9 p-4">
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      <span className="badge-custom badge-experience">
                        <i className="fa-solid fa-award me-1"></i> 23+ Years Operative Experience
                      </span>
                      <span className="badge-custom badge-time">
                        <i className="fa-regular fa-clock me-1"></i> Clinic: 10:00 AM - 04:00 PM (Mon-Sat)
                      </span>
                    </div>

                    <div className="contact-details">
                      <div className="contact-item">
                        <span className="icon-circle">
                          <i className="fa-solid fa-hospital text-teal"></i>
                        </span>
                        <span>Medicover Out Patient Center, HUDA Techno Enclave, HITEC City, Hyderabad, 500081</span>
                      </div>
                      <div className="contact-item">
                        <span className="icon-circle">
                          <i className="fa-solid fa-phone text-teal"></i>
                        </span>
                        <span>+91 8341555765 / 040-68334455</span>
                      </div>
                    </div>

                    <div className="mt-4">
                      <Link className="btn-medical-primary me-3" to="/bookappointment">
                        <i className="fa-regular fa-calendar-check me-2"></i> Book Consultation
                      </Link>
                      <Link className="btn-medical-secondary" to="/services">
                        View Surgeries
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Left Column: Languages & Quick Info */}
          <div className="col-lg-4">
            <div className="card profile-card h-100">
              <div className="card-header-custom">
                <h3>Languages Spoken</h3>
              </div>
              <div className="card-body p-4">
                <ul className="language-list">
                  {["English (Fluent)", "తెలుగు (Telugu - Native)", "हिन्दी (Hindi - Fluent)", "मराठी (Marathi - Conversational)"].map((lang, index) => (
                    <li key={index}>
                      <span className="check-icon">✓</span> {lang}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Right Column: Expertise */}
          <div className="col-lg-8">
            <div className="card profile-card h-100">
              <div className="card-header-custom">
                <h3>Surgical & Clinical Expertise</h3>
              </div>
              <div className="card-body p-4">
                <div className="expertise-wrapper">
                  {[
                    "Knee Arthroscopy", "Shoulder Arthroscopy", "Robotic Knee Replacement",
                    "Reverse Shoulder Arthroplasty", "ACL & PCL Reconstruction", "Meniscal All-Inside Repair",
                    "Rotator Cuff Tendon Repair", "Bankart Instability Surgery", "Multi-Ligament Reconstruction",
                    "High Tibial Osteotomy (HTO)", "Revision Knee Replacement", "Revision ACL Reconstruction",
                    "Complex Orthopedic Trauma", "Cartilage Preservation & Injections"
                  ].map((item, index) => (
                    <span key={index} className="expertise-pill">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section: Publications */}
          <div className="col-12 mb-4">
            <div className="card profile-card">
              <div className="card-header-custom">
                <h3>Selected International Research & Publications</h3>
              </div>
              <div className="card-body p-4">
                <ul className="publications-list">
                  {[
                    "Dynamic nature of alignment and variations in normal knees. K Deep, KK Eachempati. British Journal of Joint Surgery (BJJ), 2014.",
                    "Review: Femoral tunnel placement for PCL reconstruction in relation to the PCL fibre bundle attachments. Knee Surg Sports Traumatol Arthrosc. 2009.",
                    "Sudden loss of visual acuity following intra-articular steroid injection to the knee joint: a case report. Cases Journal, 2008.",
                    "The role of PCL reconstruction in knees with combined PCL and posterolateral corner deficiency. Knee Surg Sports Traumatol Arthrosc. 2008.",
                    "Control of laxity in knees with combined posterior cruciate ligament and posterolateral corner deficiency. American Journal of Sports Medicine (AJSM), 2008."
                  ].map((item, index) => (
                    <li key={index} className="publication-item">
                      <span className="pub-number">{index + 1}</span>
                      <p>{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorProfile;